import * as React from 'react';
import { connect } from 'react-redux';
import { Vegobjekttype } from '@/domain/vegobjekter/Vegobjekttype';
import { VegobjekttypeCategoryState, VegobjekttypeState } from '@/state';
import Accordion from '../../../objects/Accordion';
import { Loading } from '../../../objects/Loading';
import { DownloadResultsBox } from '../DownloadResultsBox';
import { RoadRefOrAreaSummary } from '../RoadRefOrAreaSummary';
import { toggleCategory } from '@/actions/vegobjekterActions';
import { VegobjekterResult } from '@/domain/vegobjekter/VegobjekterResult';
import { HitStatistics } from '../HitStatistics';
import { EgenskapTillattVerdi } from '@/domain/vegobjekter/Egenskapstype';
import { OperatorE } from '@/middleware/queries';

interface TagProps {
    vegobjekttypeData: VegobjekttypeState;
    categoryState: VegobjekttypeCategoryState;
    vegobjekttype: Vegobjekttype;
    result: VegobjekterResult;
    color: string;
    onOpenColorMenu: (
        categoryState: VegobjekttypeCategoryState,
        anchor: { x: number; y: number }
    ) => void;
}

interface DispatchProps {
    doToggleCategoryVisibility: (
        votTypeId: number,
        votCategoryState: VegobjekttypeCategoryState
    ) => void;
}

interface CategoryResultState {
    showSummary: boolean;
}

const mapDispatchToProps = {
    doToggleCategoryVisibility: toggleCategory,
};

type Props = TagProps & DispatchProps;
class CategoryResultContainer extends React.PureComponent<Props, CategoryResultState> {
    constructor(props: Props) {
        super(props);
        this.state = {
            showSummary: false,
        };
    }
    render() {
        const {
            vegobjekttype,
            categoryState,
            vegobjekttypeData,
            color,
            doToggleCategoryVisibility,
            onOpenColorMenu,
        } = this.props;
        const categoryFilter = categoryState.filters[0];
        const typeId = vegobjekttypeData.typeId;
        if (typeId === null) {
            throw new Error('Kan ikke vise kategori uten vegobjekttype-ID');
        }
        const isVisible = categoryState.visible && vegobjekttypeData.visible;
        const visibilityIcon = vegobjekttype.isLine() ? 'timeline' : 'room';
        return (
            <li className="c-category-result-list__element">
                <header className="c-hva-info__header">
                    <button
                        type="button"
                        className="material-icons c-category-result__visible-icon"
                        onClick={() => doToggleCategoryVisibility(typeId, categoryState)}
                        onContextMenu={e => {
                            e.preventDefault();
                            onOpenColorMenu(categoryState, {
                                x: e.clientX,
                                y: e.clientY,
                            });
                        }}
                        style={{ color: isVisible ? color : '#c6c6c6' }}
                        aria-label={`Vis ${
                            categoryState.filters[0].egenskapstype.navn
                        } ${categoryState.toString()} i kart. Høyreklikk for å endre farge.`}
                        data-category-value={
                            categoryFilter.operator === OperatorE.NO_VALUE
                                ? 'ingen-verdi'
                                : categoryFilter.verdi instanceof EgenskapTillattVerdi
                                  ? categoryFilter.verdi.id
                                  : undefined
                        }
                        aria-pressed={isVisible}
                    >
                        {visibilityIcon}
                    </button>
                    <h4 className="c-hva-info c-hva-info__subtitle">
                        {categoryState.toString()}
                    </h4>
                </header>
                <Accordion
                    className="c-what-accordion"
                    header={this.getResultHeader()}
                    ariaLabel={`Vis liste av ${vegobjekttype.navn} objekter med ${
                        categoryState.filters[0].egenskapstype.navn
                    } ${categoryState.toString()}`}
                >
                    {this.getResultContent()}
                </Accordion>
            </li>
        );
    }

    getResultHeader = () => {
        const { vegobjekttype, vegobjekttypeData, categoryState } = this.props;
        return (
            <>
                {vegobjekttypeData.loading && (
                    <Loading className="c-hva-info__category-statistics" type="text" />
                )}
                {!this.props.vegobjekttypeData.loading && categoryState.result && (
                    <HitStatistics
                        vegobjekttype={vegobjekttype}
                        result={categoryState.result}
                    />
                )}
            </>
        );
    };

    getResultContent = () => {
        const { categoryState, vegobjekttypeData } = this.props;

        return (
            <div className={`c-hva-list-element__filter-and-category`}>
                <RoadRefOrAreaSummary results={this.props.result} />
                <DownloadResultsBox
                    votState={vegobjekttypeData}
                    catState={categoryState}
                />
            </div>
        );
    };
}

export const CategoryResult = connect(null, mapDispatchToProps)(CategoryResultContainer);
